import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import * as styles from "./Modal.module.css";

// The 'portal-root' div needs to be added to your public/index.html file
const modalRoot = document.getElementById("portal-root");

const Modal = ({ isOpen, onClose, children }) => {
  // Add an effect to handle the 'Escape' key to close the modal
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEsc);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  // If the modal isn't open, don't render anything
  if (!isOpen) return null;
  // Use the portal to render the modal's JSX
  return ReactDOM.createPortal(
    <div className={`${styles.modalBackdrop} blur_card`}>
      <div className={`${styles.modalContent} blur_card`}>
        <span className={styles.closeButton} onClick={onClose}>
          ×
        </span>
        {children}
      </div>
    </div>,
    modalRoot // The target DOM node
  );
};

export default Modal;
